import { styled } from "@mui/material/styles";
import { Box, Stack, Typography, Checkbox } from "@mui/material";
import { colors } from "../../../theme/theme";
import { Gapper } from "../../ui/Gapper";

export const ContentBox = styled(Gapper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(4),
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  ...theme.heading2,
  color: colors.primary,
  [theme.breakpoints.down("md")]: {
    fontSize: "20px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.spacing(2),
  },
}));

export const ToggleLabel = styled(Typography)({
  color: colors.primary,
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
});

export const GridContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  gap: theme.spacing(2),
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

export const InputWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "auto",
  width: "100%",
}));

export const DateLabel = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "1rem",
  color: colors.primary,
  fontWeight: "600",
  marginBottom: theme.spacing(1),
  minHeight: 24,
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
  },
}));

export const DateHint = styled("p")(({ theme }) => ({
  color: "rgba(73,42,24, 0.6)",
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
  marginBottom: theme.spacing(2),
}));

export const DisclaimerStack = styled(Stack)({});

export const DisclaimerText = styled(Typography)(({ theme }) => ({
  ...theme.body,
  fontStyle: "italic",
  color: colors.primary,
  fontSize: "14px",
}));

export const ResultBox = styled(Box)(({ theme }) => ({
  height: "100px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(4),
  flexWrap: "wrap",

  [theme.breakpoints.down("sm")]: {
    height: "50px",
    gap: theme.spacing(2),
  },
  [theme.breakpoints.down(480)]: {
    height: "70px",
    gap: theme.spacing(0),
  },
}));

export const ResultLabel = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "24px",
  fontWeight: "600",
  textAlign: "end",
  color: colors.primary,
  [theme.breakpoints.down("md")]: {
    fontSize: "20px",
  },
}));

export const ResultAmount = styled(Typography)({
  fontFamily: "'Gotham', sans-serif",
  fontSize: "32px",
  color: colors.primary,
});

export const ResultValue = styled(Typography)(({ theme }) => ({
  fontFamily: "'Gotham', sans-serif",
  fontSize: "50px",
  color: colors.primary,
  lineHeight: ".5rem",
  [theme.breakpoints.down("md")]: {
    fontSize: "40px",
  },
}));

export const ResultSuffix = styled(Typography)({
  fontFamily: "'Gotham', sans-serif",
  fontSize: "20px",
  color: colors.primary,
});

export const CheckboxIcon = styled(Checkbox)({
  color: colors.primary,
  width: 30,
  height: 30,
});

export const checkboxIconSx = {
  color: colors.primary,
  opacity: 0.3,
};

export const checkboxCheckedIconSx = {
  color: colors.primary,
};
